export enum MemberActivity{
    AccountUnLock =108,
    changesponsor=109
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-activity-type.enum.ts